var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "400px" },
          model: {
            value: _vm.editChannel,
            callback: function($$v) {
              _vm.editChannel = $$v
            },
            expression: "editChannel"
          }
        },
        [
          _c(
            "v-form",
            {
              staticClass: "collaborators__form-dialog channel__modal-style",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                }
              }
            },
            [
              _c("v-card-title", { staticClass: "collaborators__form-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.title))])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-text-field", {
                        staticStyle: { flex: "auto" },
                        attrs: {
                          label: "Nombres",
                          error: _vm.$v.nameChannel.$error,
                          "error-messages": _vm.nameChannelErrorMessages,
                          maxlength: 40
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.nameChannel.$touch()
                          },
                          keypress: _vm.lettersAndNumbers,
                          keyup: _vm.validName
                        },
                        model: {
                          value: _vm.nameChannel,
                          callback: function($$v) {
                            _vm.nameChannel =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "nameChannel"
                        }
                      }),
                      _c("v-checkbox", {
                        staticClass: "collaborators__checkbox",
                        attrs: { label: "Puede afiliar productos virtuales" },
                        model: {
                          value: _vm.checkbox,
                          callback: function($$v) {
                            _vm.checkbox = $$v
                          },
                          expression: "checkbox"
                        }
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.$isAdmin() ||
                                (_vm.$isBoss() && _vm.conditionalStatus),
                              expression:
                                "$isAdmin() || $isBoss() && conditionalStatus"
                            }
                          ],
                          staticClass: "slide__item-switch"
                        },
                        [
                          _c("h3", [_vm._v("Estado")]),
                          _c(
                            "div",
                            { staticClass: "slide__switch" },
                            [
                              _c("v-switch", {
                                staticStyle: { flex: "none" },
                                attrs: {
                                  disabled: _vm.loading || !_vm.channelIsActive
                                },
                                model: {
                                  value: _vm.switchState,
                                  callback: function($$v) {
                                    _vm.switchState = $$v
                                  },
                                  expression: "switchState"
                                }
                              }),
                              _vm.switchState
                                ? _c("p", [_vm._v("Activo")])
                                : _c("p", [_vm._v("Inactivo")])
                            ],
                            1
                          ),
                          _vm.conditionalShowMessageStatus
                            ? _c(
                                "p",
                                { staticClass: "collaborators-message" },
                                [
                                  _vm._v(
                                    '"Si desactiva al canal, los usuarios no podrán acceder al sistema"'
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "collaborators__buttons-container w100" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-button text black uppercase",
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel($event)
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "primary-button blue w110",
                      attrs: {
                        disabled:
                          _vm.sending ||
                          _vm.$v.$invalid ||
                          !_vm.resultValidNameService,
                        type: "submit"
                      },
                      nativeOn: {
                        click: function($event) {
                          _vm.editChannel = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.actionButton))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad861a1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad861a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/edit-channel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-ad861a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/edit-channel.vue
// module chunks = 4 6 9